import { render, staticRenderFns } from "./pieCom.vue?vue&type=template&id=dd9e693c&scoped=true"
import script from "./pieCom.vue?vue&type=script&lang=js"
export * from "./pieCom.vue?vue&type=script&lang=js"
import style0 from "./pieCom.vue?vue&type=style&index=0&id=dd9e693c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9e693c",
  null
  
)

export default component.exports